import { languages } from 'monaco-editor/esm/vs/editor/editor.api';

export const granetLanguageConfig: languages.LanguageConfiguration = {
    brackets: [
        ['{', '}'],
        ['[', ']'],
        ['(', ')'],
    ],
    autoClosingPairs: [
        {
            open: '{',
            close: '}',
        },
        {
            open: '[',
            close: ']',
        },
        {
            open: '(',
            close: ')',
        },
        {
            open: '"',
            close: '"',
        },
    ],
    comments: {
        lineComment: '#',
    },
    onEnterRules: [
        {
            action: {
                indentAction: languages.IndentAction.Indent,
            },
            beforeText: /:\s*$/,
        },
    ],
};
